import { render, staticRenderFns } from "./TestTornelli.vue?vue&type=template&id=076b8d08&scoped=true&"
import script from "./TestTornelli.vue?vue&type=script&lang=js&"
export * from "./TestTornelli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b8d08",
  null
  
)

export default component.exports